<template>
  <b-dropdown-item
    link-class="d-flex align-items-center justify-content-between"
    class="notification-permissions"
    @click="handleNotificationPermissionClick"
  >
    <div
      v-b-tooltip
      class="d-flex align-items-center"
      :title="$t(tooltipKey)"
    >
      <feather-icon
        size="16"
        icon="BellIcon"
        :class="['mr-50', notificationPermissionGranted ? 'text-success' : 'text-danger']"
      />
      <span :class="[notificationPermissionGranted ? 'text-success' : 'text-danger']">
        {{ $t('user-profile.notification-permissions.label') }}
      </span>
    </div>
  </b-dropdown-item>
</template>

<script>
import { BDropdownItem, VBTooltip } from 'bootstrap-vue'

export default {
  name: 'NotificationPermissionItem',
  components: { BDropdownItem },
  directives: { 'b-tooltip': VBTooltip },
  data() {
    return {
      notificationPermissionState: this.getInitialPermissionState(),
    }
  },
  computed: {
    notificationPermissionGranted() {
      return this.notificationPermissionState === 'granted'
    },
    tooltipKey() {
      return this.notificationPermissionGranted
        ? 'user-profile.notification-permissions.granted'
        : 'user-profile.notification-permissions.denied'
    },
  },
  methods: {
    getInitialPermissionState() {
      if (typeof window === 'undefined' || typeof Notification === 'undefined') {
        return 'denied'
      }
      return Notification.permission
    },
    handleNotificationPermissionClick() {
      if (this.notificationPermissionGranted) {
        return
      }
      this.requestNotificationPermission()
    },
    requestNotificationPermission() {
      if (typeof window === 'undefined' || typeof Notification === 'undefined') {
        return
      }
      const result = Notification.requestPermission()
      if (result && typeof result.then === 'function') {
        result.then(permission => {
          this.notificationPermissionState = permission
        })
      } else if (typeof result === 'string') {
        this.notificationPermissionState = result
      }
    },
  },
}
</script>
